module.exports = __webpack_public_path__ + "assets/0adbf4a8d616667232e0fc56e2a08438.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Quadon-Medium.woff
 ** module id = 1741
 ** module chunks = 1
 **/